import { render, staticRenderFns } from "./FicheSiren.vue?vue&type=template&id=9c480e2c"
import script from "./FicheSiren.vue?vue&type=script&lang=js"
export * from "./FicheSiren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports